'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCustomEqualSelector = exports.createCustomEqualShallowSelector = exports.createImmutableShallowSelector = exports.createShallowSelector = exports.defaultMilanoteMemoize = undefined;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _recompose = require('recompose');

var _reselect = require('reselect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var defaultMilanoteMemoize = exports.defaultMilanoteMemoize = function defaultMilanoteMemoize() {
    var equalityCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _recompose.shallowEqual;
    return function (func) {
        var lastArgs = null;
        var lastResult = null;

        return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (lastArgs !== null && lastArgs.length === args.length && args.every(function (value, index) {
                return equalityCheck(value, lastArgs[index]);
            })) {
                return lastResult;
            }
            var newResult = func.apply(undefined, args);
            if (!(0, _recompose.shallowEqual)(lastResult, newResult)) {
                lastResult = newResult;
            }
            lastArgs = args;
            return lastResult;
        };
    };
};

var createShallowSelector = exports.createShallowSelector = (0, _reselect.createSelectorCreator)(defaultMilanoteMemoize());
var createImmutableShallowSelector = exports.createImmutableShallowSelector = (0, _reselect.createSelectorCreator)(defaultMilanoteMemoize(Immutable.is));

var createCustomEqualShallowSelector = exports.createCustomEqualShallowSelector = function createCustomEqualShallowSelector(equalityCheckFn) {
    return (0, _reselect.createSelectorCreator)(defaultMilanoteMemoize(equalityCheckFn));
};
var createCustomEqualSelector = exports.createCustomEqualSelector = function createCustomEqualSelector(equalityCheckFn) {
    return (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, equalityCheckFn);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/milanoteReselect/milanoteReselect.js
// module id = 49
// module chunks = 0